import { AnalyticsStore, SerializedData } from 'bernie-core';
import { BexApiStore, RequestOptions } from 'bernie-graphql';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import analyticsWrapper from 'utility/analytics-wrapper';
import {
  FlightsShoppingPwaFlightInformationResults,
  FlightsShoppingPwaFlightInformationResultsLoading
} from '__generated__/api/';

/* istanbul ignore next */
export class InformationResultStore extends BexApiStore {
  public hydrate(data: SerializedData): void {
    super.hydrate(data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  private addClientInfoHeader(headers, appName, region) {
    return {
      ...headers,
      'Client-Info': `${appName},latest,${region || 'external'}`
    };
  }

  public fetchLoading(
    detailsVariables: FlightsShoppingPwaFlightInformationResultsLoading.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightInformationResultsLoading.FlightsDetail> {
    this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), this.bexApiSource.clientConfigs.bexApiUrl);

    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = this.addClientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightInformationResultsLoading(detailsVariables, options)
      .then(response => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), JSON.stringify(detailsVariables));
        this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), JSON.stringify(response));
        const { flightsDetail } = response.data;

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsDetail
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVERROR'), error);

        return null;
      });
  }

  public fetchResults(
    detailsVariables: FlightsShoppingPwaFlightInformationResults.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightInformationResults.FlightsDetail> {
    this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), this.bexApiSource.clientConfigs.bexApiUrl);

    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = this.addClientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightInformationResults(detailsVariables, options)
      .then(response => {
        const { flightsDetail } = response.data;

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsDetail
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVERROR'), error);

        return null;
      });
  }
}
